module.exports = __webpack_public_path__ + "cf41a3163197f9fd7b650921f7f979dc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/stamps/animal-kawauso-angry-face.png
// module id = 2093
// module chunks = 4